<template>
    <div class="password-recovery-confirm">
        <HeaderCentered>
            <template #title>
                {{ $t('login.password_recovery.confirm.title') }}
                <div class="email">{{ recoveryEmail }}</div>
            </template>
        </HeaderCentered>
        <OtCardContent class="password-email-sent">
            <div class="password-email-sent__text">
                {{ $t('login.password_recovery.confirm.explanation') }}
            </div>
            <OtButton
                class="ot-button is-dark"
                @click="$router.push({name: 'login', query: $route.query})"
                :title="$t('login.password_recovery.confirm.next.title')"
            >
                <i class="oti oti-check ot-button-icon--left"/>
                {{ $t('login.password_recovery.confirm.next.text') }}
            </OtButton>
        </OtCardContent>
    </div>
</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-property-decorator';
import HeaderCentered from '../HeaderCentered.vue';
import OtButton from '../OtButton.vue';

@Component({ components: { HeaderCentered, OtButton } })
export default class PasswordRecoveryConfirmation extends Vue {

    @Prop() recoveryEmail!: string;

}
</script>

<style lang="scss" scoped>
.password-email-sent {
    text-align: center;

    &__text {
        font-weight: 400;
        text-align: center;
        font-size: 16px;
        margin-bottom: var(--ot-spacing-2xl);
        color: var(--ot-color-core-light-foreground-secondary);

    }
}

.email {
    color: var(--ot-color-core-brand);
}

.card-temporary-wrapper {
    display: flex;
    align-items: center;
    height: 100vh;
    width: 100%;
    justify-content: center;
}
</style>
